// extracted by mini-css-extract-plugin
export default {"printable":"evaluationRequestDetail_printable__-91ed"};